export default "__VITE_ASSET__CboZVVXZ__"